import React, { useState } from "react";
import Flatpickr from "react-flatpickr";
import { useGetProjectsByDropDownQuery } from "slices/projects/projectSlice";

// Define PO status options based on your Django filter
const PO_STATUS_OPTIONS = [
  { id: "submitted", status_name: "Submitted" },
  { id: "approved", status_name: "Approved" },
  { id: "rejected", status_name: "Rejected" },
  { id: "cancelled", status_name: "Cancelled" },
  // { id: "partially_delivered", status_name: "Partially Delivered" },
  // { id: "delivered", status_name: "Delivered" },
];

// Define Delivery status options based on your Django filter
const DELIVERY_STATUS_OPTIONS = [
  { id: "pending", status_name: "Pending" },
  // { id: "in_progress", status_name: "In Progress" },
  { id: "partially_delivered", status_name: "Partially Delivered" },
  { id: "delivered", status_name: "Delivered" },
  { id: "cancelled", status_name: "Cancelled" },
];

export const PurchaseOrderGlobalFilter = ({ setPageState, globalValue }: any) => {
    
  const { data: Projects } = useGetProjectsByDropDownQuery(undefined);

  const [dateRange, setDateRange] = useState([null, null]);

  const poStatusOnChange = (value: string) => {
    setPageState((prev: any) => ({
      ...prev,
      po_status: value,
      page: 1,
    }));
  };

  const deliveryStatusOnChange = (value: string) => {
    setPageState((prev: any) => ({
      ...prev,
      delivery_status: value,
      page: 1,
    }));
  };

  const projectsOnChange = (value: string) => {
    setPageState((prev: any) => ({
      ...prev,
      project: value,
      page: 1,
    }));
  };

  // If you want to use the commented date functionality later
  // const handleDateChange = (selectedDates: any) => {
  //   if (selectedDates.length === 2) {
  //     const [startDate, endDate] = selectedDates;
  //     setDateRange([startDate, endDate]);

  //     let startDateString = startDate.toISOString().split("T")[0];
  //     let dueDateString = endDate.toISOString().split("T")[0];

  //     setPageState((prev: any) => ({
  //       ...prev,
  //       start_date: startDateString,
  //       end_date: dueDateString,
  //     }));
  //   }
  // };

  return (
    <React.Fragment>
      {/* <div className="col-xxl-3 col-sm-3"> */}
        {/* Date filter - uncomment when needed */}
        {/* <Flatpickr
          placeholder="Select start & due date range"
          className="form-control bg-light border-light"
          options={{
            mode: "range",
            dateFormat: "d-m-Y",
          }}
          value={dateRange}
          onChange={handleDateChange}
        /> */}
      {/* </div> */}

      {/* PO Status Filter */}
      <div className="col-xxl-3 col-sm-3">
        <div className="input-light">
          <select
            onChange={(e) => poStatusOnChange(e.target.value)}
            className="form-control"
            data-choices
            data-choices-search-false
            name="po_status"
            id="idPoStatus"
          >
            <option value="" className="text-muted">
              All PO Status
            </option>
            {PO_STATUS_OPTIONS?.map((options: any) => (
              <option key={options.id} value={options.id}>
                {options.status_name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Delivery Status Filter */}
      <div className="col-xxl-3 col-sm-3">
        <div className="input-light">
          <select
            onChange={(e) => deliveryStatusOnChange(e.target.value)}
            className="form-control"
            data-choices
            data-choices-search-false
            name="delivery_status"
            id="idDeliveryStatus"
          >
            <option value="" className="text-muted">
              All Delivery Status
            </option>
            {DELIVERY_STATUS_OPTIONS?.map((options: any) => (
              <option key={options.id} value={options.id}>
                {options.status_name}
              </option>
            ))}
          </select>
        </div>
      </div>
      
      {/* Projects Filter */}
      <div className="col-xxl-3 col-sm-3">
        <div className="input-light">
          <select
            onChange={(e) => projectsOnChange(e.target.value)}
            className="form-control"
            data-choices
            data-choices-search-false
            name="project"
            id="idProject"
          >
            <option value="">All Projects</option>
            {Projects?.map((options: any) => (
              <option key={options.id} value={options.id}>
                {options.project_name} ({options.project_short_name})
              </option>
            ))}
          </select>
        </div>
      </div>
    </React.Fragment>
  );
};